<template lang="">
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 53.66 53.66">
  <g id="Text_Us" data-name="Text Us" transform="translate(-1115.944 -489.701)">
    <circle id="Ellipse_1081" data-name="Ellipse 1081" cx="26.33" cy="26.33" r="26.33" transform="translate(1116.444 490.201)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    <g id="Group_8623" data-name="Group 8623" transform="translate(1135.001 502.671)">
      <rect id="Rectangle_4385" data-name="Rectangle 4385" width="15.796" height="27.947" rx="1.862" transform="translate(0)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <line id="Line_923" data-name="Line 923" x2="15.796" transform="translate(0 23.086)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <line id="Line_924" data-name="Line 924" x2="3.645" transform="translate(6.075 2.43)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1"/>
      <line id="Line_925" data-name="Line 925" x2="1.215" transform="translate(7.29 25.517)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    </g>
  </g>
</svg>

  </div>
</template>
<script>
export default {
  props: {
    themeColor: {
      type: String,
      default: '#B3B3B3'
    },
    height: {
      type: String,
      default: '53.66px'
    },
    width: {
      type: String,
      default: '53.66px'
    }
  }
}
</script>
<style lang="">

</style>
